export default class Param {
    constructor(){

        this.breakpoint = 750;
        this.displayType = (window.innerWidth>this.breakpoint)?"pc":"sp";
        if(Useragnt.mobile){
            this.userAgent = "sp";
        }else if(Useragnt.tablet){
            this.userAgent = "tablet";
        }else{
            this.userAgent = "pc";
        }
        if(document.querySelector("html").classList.contains('ie') || document.querySelector("html").classList.contains('edge')){
            this.browserType = 'IE';
        }else if(document.querySelector("html").classList.contains('safari') && document.querySelector("html").classList.contains('pc')){
            this.browserType = 'safari';
        }else{
            this.browserType = 'other';
        }
        this.type = 'full';

        this.ease = CustomEase.create("custom", "M0,0 C0.246,0.412 0.258,0.896 0.512,0.984 0.669,1.038 0.838,1 1,1");
        this.easePop = CustomEase.create("custom", "M0,0 C0,0 -0.004,0.248 0.032,0.688 0.069,1.071 0.144,1.016 0.198,1.016 0.256,1 0.276,0.978 0.344,0.978 0.416,0.978 0.41,0.988 0.486,1 0.565,1.012 0.618,1 0.72,1 0.802,1 0.798,1 0.856,1 0.922,1 0.885,1 0.944,1 0.98,1 1,1 1,1");

    }
}
